import { __awaiter, __generator } from "tslib";
export var noop = function () {
    var _ = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        _[_i] = arguments[_i];
    }
    return null;
};
export var asyncNoop = function () {
    var _ = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        _[_i] = arguments[_i];
    }
    return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        return [2 /*return*/, Promise.resolve({})];
    }); });
};
//# sourceMappingURL=noop.js.map